// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3303b241","453":"8bfa632f","455":"d10bdb03","762":"3d8f73e4","977":"c917db0d"}[chunkId] + ".chunk.js";
};